module.exports = __webpack_public_path__ + "img/cannyhr-logo.eda50919.webp";